import 'react-datepicker/dist/react-datepicker.css';
import './Filters.scss';

import React, { Component } from 'react';

import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { TimeUtils } from './../chart-components/ChartUtils/TimeUtils';
import nb from 'date-fns/locale/nb';

export class FilterToFromDate2 extends Component {
  static propTypes = {
    setFilter: PropTypes.func.isRequired,
    filter: PropTypes.object,
    minTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    maxTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    format: PropTypes.string
  };

  static defaultProps = {
    filter: {},
    minTime: new Date(2005, 0, 1),
    maxTime: TimeUtils.getDateDiff(0),
    format: 'dd.MM.yyyy HH:mm'
  };

  constructor (props) {
    super(props);
    this.state = {
      filter: props.filter
    };
    this.update = this.update.bind(this);
  }

  update (key, val) {
    const { filter, setFilter } = this.props;
    filter[key] = val;

    setFilter({
      'fromTime': filter.fromTime,
      'toTime': filter.toTime
    });

    this.setState(filter);
  }

  render () {
    const { format } = this.props;
    var { fromTime, toTime } = this.props.filter;

    var { maxTime, minTime } = this.props;

    var yesterday = new Date(maxTime);
    yesterday.setDate(yesterday.getDate() - 3);

    fromTime = fromTime ? new Date(fromTime) : yesterday;
    toTime = toTime ? new Date(toTime) : maxTime;

    return (
      <div key='fromTime'>
        <div className='dropdown--container'>
          <label>From date</label>
          <ReactDatePicker
            selected={fromTime}
            onChange={date => this.update('fromTime', date)}
            locale={nb}
            dateFormat={format}
            minDate={minTime}
            maxDate={maxTime}
            selectsStart
            startDate={fromTime}
            endDate={toTime}
            showWeekNumbers
            monthsShown={1}
            isClearable
            showYearDropdown
            showMonthDropdown
          />
        </div>
        <div className='dropdown--container'>
          <label>To date</label>
          <ReactDatePicker
            selected={toTime}
            onChange={date => this.update('toTime', date)}
            locale={nb}
            dateFormat={format}
            minDate={minTime}
            maxDate={maxTime}
            selectsEnd
            startDate={fromTime}
            endDate={toTime}
            showWeekNumbers
            monthsShown={1}
            isClearable
            showYearDropdown
            showMonthDropdown
          />
        </div >
      </div>
    );
  }
}
